<template>
  <div>
    <div class="posiCent">
      <p class="loadingModal-global">{{ message }}</p>
      <div class="loadingModal-circularWrapper">
        <tk-circular-progress
          v-for="item in numberOfSpinner"
          :key="item"
          :turning="item === indexOfTurning"
        ></tk-circular-progress>
      </div>
    </div>
    <div class="loadingModal-bar">
      <span
        class="loadingModal-loadedBar"
        :style="{ width: progress + '%' }"
      ></span>
    </div>
  </div>
</template>

<script>
import TkCircularProgress from '../../atoms/TkCircularProgress/TkCircularProgress.vue'
const MAX_WIDTH_PROGRESS_BAR = 100
const MIN_WIDTH_PROGRESS_BAR = 0
const NUMBER_OF_SPINNER = 4
const DISTANCE_OF_FLIGHT = 140
const defaultStyleMessage = {
  bottom: '200px',
}
export default {
  name: 'TkGlobalLoadingProgressbar',
  components: {
    TkCircularProgress,
  },
  props: {
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      progress: MIN_WIDTH_PROGRESS_BAR,
      numberOfSpinner: [...Array(NUMBER_OF_SPINNER).keys()],
      styleMessage: null,
    }
  },
  computed: {
    alignFlightIcon() {
      return (
        (DISTANCE_OF_FLIGHT * this.progress) / MAX_WIDTH_PROGRESS_BAR -
        DISTANCE_OF_FLIGHT / 2
      )
    },
    indexOfTurning() {
      const idx = Math.floor(
        (NUMBER_OF_SPINNER * this.progress) / MAX_WIDTH_PROGRESS_BAR
      )
      return idx < NUMBER_OF_SPINNER ? idx : NUMBER_OF_SPINNER - 1
    },
  },
  created() {
    const userAgent = navigator.userAgent.toLowerCase()
    if (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('android') > -1) {
      this.styleMessage = defaultStyleMessage
    }
  },
  mounted() {
    const timer = setInterval(() => {
      if (this.progress < MAX_WIDTH_PROGRESS_BAR) {
        this.progress += Math.floor(Math.random() * 3)
      } else {
        clearInterval(timer)
      }
    }, 100)

    this.$once('hook:beforeDestroy', () => {
      if (timer) {
        clearInterval(timer)
      }
    })
  },
}
</script>

<style lang="scss">
@import '~@ota-frontend/ui/src/scss/components/TkGlobalLoadingProgressbar.scss';
</style>
